export default "__VITE_ASSET__C2poNFZv__"